<script>
import searchResultsTabMixin from '@phoenix/mixins/searchResultsTabMixin';
import SearchResultsTab from '@maison/components/search/SearchResultsTab';
import ArticleTile from '@maison/components/article/ArticleTile';
import { TAB_SERVICES } from '@maison/helpers/search-helper';
import { IndexNames } from '@module/Algolia/resources/js/search/AlgoliaSearch';
import { algoliaTracking } from '@module/Algolia/resources/js/insights/helpers';

export default {
  components: {
    SearchResultsTab,
    ArticleTile,
  },

  mixins: [searchResultsTabMixin],

  data() {
    return {
      tab: TAB_SERVICES,
    };
  },

  methods: {
    onServiceClick(service, position) {
      algoliaTracking(service, position, IndexNames.Articles);
    },
  },
};
</script>

<template>
  <search-results-tab :tab="tab" :limit="limit" has-paging-label>
    <ul class="grid gap-base lg:grid-cols-3">
      <li v-for="(service, position) in items" :key="service.id" role="presentation">
        <article-tile v-bind="service" :data-tracking="dataTracking" @click="onServiceClick(service, position)" />
      </li>
    </ul>
  </search-results-tab>
</template>
